import UserService from '@/services/UserService';
import { importScript } from './utils.js';

export default class SurveyUtils {
  static async install(data) {
    await importScript('//survey.survicate.com/workspaces/8dc7c7b2a7d32ffe7427bd8dbb9edf10/web_surveys.js');

    let count = 0;
    let interval = null;

    const clear = () => {
      if (interval) {
        clearInterval(interval);
      }
    };

    const callback = () => {
      if (count > 5) {
        clear();
        return;
      }

      count += 1;

      try {
        if (SurveyUtils.isInstalled) {
          SurveyUtils.sendData({
            user_id: UserService.getEmail(),
            ...data,
          });

          clear();
        }
      } catch (error) {
        console.error(error);
      }
    };

    interval = setInterval(callback, 2000);
  }

  static sendData(data) {
    if (data) {
      SurveyUtils.instance.traits = data;
    }
  }

  static get instance() {
    return window._sva;
  }

  static showSurvey(id) {
    SurveyUtils.instance.destroyVisitor(() => {
      SurveyUtils.instance.showSurvey(id, {
        forceDisplay: true,
      });
    });
  }

  static get isInstalled() {
    return '_sva' in window;
  }
}
